'use strict';

/**
 * Single frontend source of truth for address structural validation rules.
 *
 * Only validation LOGIC lives here (required, pattern, min, value normalizer).
 * maxLength stays enforced by the HTML attribute rendered from the XML
 * (single source per the Matriz); labels, placeholders and messages keep
 * living in their current layers (XML/ISML/properties via data-missing-error,
 * data-pattern-mismatch, data-minlength-error attributes).
 */
var ADDRESS_FIELD_CONTRACT = {
    address1: { required: true, pattern: /^[A-Za-z0-9ÁÉÍÓÚáéíóúÜüÑñ\s().,/-]+$/ },
    externalNumber: { required: true, pattern: /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ0-9\s./\\#,-]*$/ },
    interiorNumber: { required: false, pattern: /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ0-9\s./\\#,-]*$/ },
    postalCode: { required: true, pattern: /^\d{5}$/ },
    neighborhood: { required: true, pattern: /^[A-Za-z0-9ÁÉÍÓÚáéíóúÜüÑñ\s().,/-]+$/ },
    city: { required: true, pattern: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ0-9\s.,-]+$/ },
    stateCode: { required: true, pattern: null },
    addressId: { required: true, pattern: /^[A-Za-z0-9ÁÉÍÓÚáéíóúÜüÑñ\s.-]+$/, min: 3 },
    firstName: { required: true, pattern: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s.'-]+$/ },
    lastName: { required: true, pattern: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s.'-]+$/ },
    phone: { required: true, pattern: /^\d{10}$/, normalize: 'digits' },
    reference: { required: false, pattern: /^[^<>\\¡!¿?&]*$/ }
};

/**
 * Derived aliases (kept for backward compatibility with existing consumers).
 */
var FIELD_REGEXES = {};
var OPTIONAL_FIELDS = [];

Object.keys(ADDRESS_FIELD_CONTRACT).forEach(function (fieldName) {
    var rule = ADDRESS_FIELD_CONTRACT[fieldName];
    if (rule.pattern) {
        FIELD_REGEXES[fieldName] = rule.pattern;
    }
    if (!rule.required) {
        OPTIONAL_FIELDS.push(fieldName);
    }
});

var REQUIRED_FIELDS = ['#address1', '#externalNumber', '#neighborhood', '#city', '#state', '#zipCode', '#phone', '#firstName', '#lastName'];

var CHECKOUT_SELECTION_RULE_FIELDS = [
    'firstName', 'lastName', 'address1', 'city', 'postalCode', 'stateCode',
    'neighborhood', 'phone', 'externalNumber', 'interiorNumber'
];

var ADDRESS_FIELD_RULES = {};

CHECKOUT_SELECTION_RULE_FIELDS.forEach(function (fieldName) {
    var rule = ADDRESS_FIELD_CONTRACT[fieldName];
    var entry = {};
    if (rule.required) {
        entry.required = true;
    }
    if (rule.pattern) {
        entry.regex = rule.pattern;
    }
    ADDRESS_FIELD_RULES[fieldName] = entry;
});

var ACCOUNT_FIELD_SELECTORS = {
    address1: '#address1',
    city: '#city',
    neighborhood: '#neighborhood',
    firstName: '#firstName',
    lastName: '#lastName',
    postalCode: '#zipCode',
    stateCode: '#state',
    phone: '#phone',
    externalNumber: '#externalNumber',
    interiorNumber: '#interiorNumber',
    addressId: '#addressId',
    reference: '#reference'
};

var CHECKOUT_FIELD_SELECTORS = {
    address1: '[name$=_address1]',
    externalNumber: '[name$=_externalNumber]',
    neighborhood: '[name$=_neighborhood]',
    city: '[name$=_city]',
    stateCode: '[name$=_stateCode]',
    postalCode: '[name$=_postalCode]',
    phone: '[name$=_phoneDisplay]',
    firstName: '[name$=_firstName]',
    lastName: '[name$=_lastName]',
    interiorNumber: '[name$=_interiorNumber]',
    addressId: '[name$=_addressId]',
    reference: '[name$=_reference]'
};

var FIELD_MESSAGE_FALLBACKS = {
    empty: 'Este campo es obligatorio',
    pattern: 'Formato inválido',
    patternByField: {
        externalNumber: 'Usa letras, números y - / \\ . # ,'
    }
};

var ADDRESS_VALIDATION_CONTEXTS = {
    account: { selectors: ACCOUNT_FIELD_SELECTORS },
    checkout: { selectors: CHECKOUT_FIELD_SELECTORS }
};

module.exports = {
    CHECKOUT_STEPS: {
        CUSTOMER: 1,
        SHIPPING: 2,
        PAYMENT: 3,
        SUMMARY: 4,
        PLACE_ORDER: 5
    },
    GOOGLE_PLACES_AUTOCOMPLETE: {
        MIN_CHARS: 3,
        DEBOUNCE_MS: 150
    },
    GOOGLE_ADDRESS: {
        REQUIRED_COMPONENTS: ['streetName', 'streetNumber', 'neighborhood', 'postalCode']
    },
    LOCKER_SHIPPING_METHOD_ID: 'pickup-locker',
    ADDRESS_FIELD_CONTRACT: ADDRESS_FIELD_CONTRACT,
    REQUIRED_FIELDS: REQUIRED_FIELDS,
    FIELD_REGEXES: FIELD_REGEXES,
    ADDRESS_FIELD_RULES: ADDRESS_FIELD_RULES,
    ACCOUNT_FIELD_SELECTORS: ACCOUNT_FIELD_SELECTORS,
    CHECKOUT_FIELD_SELECTORS: CHECKOUT_FIELD_SELECTORS,
    OPTIONAL_FIELDS: OPTIONAL_FIELDS,
    FIELD_MESSAGE_FALLBACKS: FIELD_MESSAGE_FALLBACKS,
    ADDRESS_VALIDATION_CONTEXTS: ADDRESS_VALIDATION_CONTEXTS
}
